// Cast a <video> element to a TV: AirPlay (Safari) or Remote Playback (Chrome/Android). Returns false when unsupported.
export async function castVideo(el) {
  if (!el) return false;
  try {
    if (el.webkitShowPlaybackTargetPicker) { el.webkitShowPlaybackTargetPicker(); return true; }
    if (el.remote?.prompt) { await el.remote.prompt(); return true; }
  } catch (e) { if (e?.name === "NotAllowedError" || e?.name === "AbortError") return true; }
  return false;
}
export const canCast = () => typeof HTMLMediaElement !== "undefined" && ("remote" in HTMLMediaElement.prototype || !!window.WebKitPlaybackTargetAvailabilityEvent);
